import React, { useState } from 'react';
import { ErrorMessage, FieldArray } from 'formik';
import useFieldDecorators from '../hooks/useFieldDecorators';
import Tooltip from '../common/Tooltip';
const CheckboxFieldArray = (props) => {
    const { isRequired, helpBlock, contentCssClass, labelCssClass } = useFieldDecorators(props);
    const [textFieldIsChecked, updateTextFieldIsChecked] = useState(false);
    const [textFieldValue, updateTextFieldValue] = useState('');
    return (React.createElement("div", { className: "form-group row" },
        React.createElement("label", { htmlFor: props.name, className: `${labelCssClass} control-label` },
            isRequired,
            props.label,
            " \u00A0",
            React.createElement(Tooltip, { text: props.tooltip, name: props.name })),
        React.createElement("div", { className: contentCssClass },
            React.createElement(FieldArray, { name: props.name }, (fieldArrayProps) => {
                const currentValues = fieldArrayProps.form.values[props.name];
                return [
                    Object.entries(props.checkboxes).map(([key, value]) => (React.createElement("div", { key: key },
                        React.createElement("label", null,
                            React.createElement("input", Object.assign({ name: props.name, type: "checkbox", checked: currentValues[key] !== undefined, onChange: (e) => {
                                    if (e.target.checked)
                                        fieldArrayProps.form.setFieldValue(props.name, Object.assign(Object.assign({}, currentValues), { [key]: value }));
                                    else
                                        fieldArrayProps.form.setFieldValue(props.name, Object.assign(Object.assign({}, currentValues), { [key]: undefined }));
                                } }, props.inputProps, { "data-testid": `${props.testId}-${key}` })),
                            ' ',
                            key)))),
                    props.displayTextCheckbox && (React.createElement("div", { key: `${props.name}TextCheckbox` },
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: textFieldIsChecked, onChange: () => {
                                    if (!textFieldIsChecked) {
                                        fieldArrayProps.form.setFieldValue(props.name, Object.assign(Object.assign({}, currentValues), { textBox: textFieldValue }));
                                    }
                                    else {
                                        fieldArrayProps.form.setFieldValue(props.name, Object.assign(Object.assign({}, currentValues), { textBox: undefined }));
                                    }
                                    updateTextFieldIsChecked(!textFieldIsChecked);
                                }, "data-testid": "text-checkbox" })),
                        React.createElement("input", Object.assign({ id: props.name, name: props.name, type: "text", disabled: !textFieldIsChecked, "data-testid": "text-checkbox-input", value: textFieldValue }, props.inputProps, { onChange: (e) => {
                                updateTextFieldValue(e.target.value);
                                fieldArrayProps.form.setFieldValue(props.name, Object.assign(Object.assign({}, currentValues), { textBox: e.target.value }));
                            } })))),
                ];
            }),
            React.createElement(ErrorMessage, { name: props.name, className: "text-danger", component: "small" }),
            helpBlock)));
};
export default CheckboxFieldArray;
